import { TCreateUnitRequest, TCreateUnitResponse } from "../domain/portal-unit.entities";
import { UnitGateway } from "../domain/unit.gateway";

export class CreateUnitUseCase {
    constructor(private gate: UnitGateway) {}

    async execute(params: TCreateUnitRequest): Promise<TCreateUnitResponse> {
        return this.gate.createUnit(params);
    }
}